'use client'

import { cn } from 'utils/cn'
import { MainMenu } from '../Navigation/MainMenu'
import { MegaMenu } from '../Navigation/MegaMenu'
import { QuickAccessMenu } from '../Navigation/QuickAccessMenu'
import { ProgressbarScrolling } from '../Progressbar/ProgressbarScroll'

export const headerId = 'main-header'
export const headerNavId = 'main-header-nav'
export const headerProgressbarId = 'main-header-progressbar'

interface HeaderProps {
  showSubmenu?: boolean
  isAuthenticated?: boolean
  customContent?: React.ReactNode
  customMobileContent?: React.ReactNode
  onMenuItemClick?: (args: {
    clickedElement?: string
    clickUrl?: string
  }) => void
}

export const Header = ({
  showSubmenu = true,
  customContent,
  isAuthenticated,
  customMobileContent,
  onMenuItemClick,
}: HeaderProps) => {
  return (
    <header
      className={cn(
        'bg-surface-primary relative z-40 flex flex-col items-center',
      )}
      id={headerId}
    >
      <QuickAccessMenu
        customContent={customContent}
        customMobileContent={customMobileContent}
        isAuthenticated={isAuthenticated}
        onMenuItemClick={onMenuItemClick}
      />

      <hr className='border-b-surface-disabled w-full border-0 border-b' />

      {showSubmenu ? (
        <div
          className='hidden w-full max-w-[calc(theme(screens.content)+120px)] items-center justify-between gap-2 px-4 md:px-[60px] lg:flex'
          id={headerNavId}
        >
          <MainMenu onMenuItemClick={onMenuItemClick} />
          <MegaMenu onMenuItemClick={onMenuItemClick} />
        </div>
      ) : null}

      <ProgressbarScrolling id={headerProgressbarId} />
    </header>
  )
}
